import Vue from "vue";
import * as types from "./mutation-types";

const actions = {
  fetchRegistration({ commit, dispatch }, payload) {
    const { programName, invite, programCode } = payload;

    const inviteQuery = invite ? `?invite=${invite}` : "";
    const programCodeQuery = programCode ? `&programCode=${programCode}` : "";

    return Vue.axios
      .get(`registration/${programName}${inviteQuery}${programCodeQuery}`)
      .then(response => {
        const program = response.data.data;
        commit(types.SET_PROGRAM_REGISTRATION_FIELDS, program);

        if (program.tier.includes("core")) {
          commit("program/SET_TYPE_CORETIER", true, { root: true });
        } else if (program.tier.includes("plus")) {
          commit("program/SET_TYPE_PLUSTIER", true, { root: true });
        } else if (program.tier.includes("pro")) {
          commit("program/SET_TYPE_PROTIER", true, { root: true });
        }

        if (program.type.includes("activate")) {
          commit("program/SET_TYPE_ACTIVATEPRODUCT", true, { root: true });
        } else if (program.type.includes("engage")) {
          commit("program/SET_TYPE_ENGAGEPRODUCT", true, { root: true });
        } else if (program.type.includes("thrive")) {
          commit("program/SET_TYPE_THRIVEPRODUCT", true, { root: true });
        }

        if (program.type.includes("wellness")) {
          commit("program/SET_TYPE_WELLNESS", true, { root: true });
        } else if (program.type.includes("activity")) {
          commit("program/SET_TYPE_ACTIVITY", true, { root: true });
        }
        commit(types.SET_LOADED_STATUS, {
          key: "registrationFieldsLoaded",
          value: true
        });
      })
      .catch(error => {
        commit(types.SET_PROGRAM_REGISTRATION_FIELDS, []);
        let message =
          "There is an error. " +
          Vue._.get(error, "response.data.error.message", " ") +
          " Please try again or contact wellness@be-engaged.co";
        dispatch(
          "snackBar",
          {
            message: message,
            type: "is-danger",
            queue: false,
            actionText: null,
            indefinite: true
          },
          { root: true }
        );

        throw error;
      });
  },

  async register(_, formData) {
    return Vue.axios
      .post("registration", formData)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error.response.data;
      });
  },

  forgotPassword(_, memberId) {
    return Vue.axios.post(`forgot-password`, { memberId }).catch(error => {
      throw error;
    });
  },

  resetForgotPassword({ dispatch }, payload) {
    return Vue.axios.post(`reset-password`, payload).catch(error => {
      const response = error.response.data.error;
      dispatch(
        "snackBar",
        {
          message: response.message || response.fields.token[0],
          type: "is-danger",
          queue: false,
          duration: 10000
        },
        { root: true }
      );
    });
  },

  createTeamAfterSignIn({ commit }, payload) {
    const { formData } = payload;
    commit(types.SET_CREATE_TEAM_AFTER_SIGN_IN, {
      value: true
    });
    commit(types.SET_CREATE_TEAM_FORM_DATA, {
      value: formData
    });
  },

  resetCreateTeamAfterSignIn({ commit }) {
    commit(types.SET_CREATE_TEAM_AFTER_SIGN_IN, {
      value: false
    });
    commit(types.SET_CREATE_TEAM_FORM_DATA, {
      value: {}
    });
  },

  mobileLogin(_, formData) {
    return Vue.axios
      .post("login", formData)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error.response.data;
      });
  }
};

export default actions;
